/**
 * Stato di una macchina o di una periferica, corrisponde al campo devS dei messaggi remoti mandati da Caos
 */
export enum StatusEnum {
    Unknown = -1,
    Busy = 0,
    Online = 1,
    Offline = 2,
    OutOfService = 3,
    Full = 4,
}

export function statusEnumLabel(status: StatusEnum): string {
    switch (status) {
        case StatusEnum.Online:
            return "enum.status.online";
        case StatusEnum.Busy:
            return "enum.status.busy";
        case StatusEnum.Full:
            return "enum.status.full";
        case StatusEnum.OutOfService:
            return "enum.status.outOfService";
        case StatusEnum.Offline:
            return "enum.status.offline";
        default:
            return "common.unknown";
    }
}
